/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 100);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const requestId = ++FacetFiltersForm.renderPageId;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, requestId);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event, requestId);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event, requestId) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        if (requestId !== FacetFiltersForm.renderPageId) return;
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderMobileFacets(html);
        FacetFiltersForm.renderDesktopFacets(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event, requestId) {
    if (requestId !== FacetFiltersForm.renderPageId) return;
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderMobileFacets(html);
    FacetFiltersForm.renderDesktopFacets(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderMobileFacets(html) {
    var container = document.getElementById('FacetsMobileContainer');
    if (!container) return;

    var parsedContainer = new DOMParser().parseFromString(html, 'text/html').getElementById('FacetsMobileContainer');
    if (!parsedContainer) return;

    var openBtn = document.querySelector('.facet-pill[aria-expanded="true"]');
    var openId = openBtn ? openBtn.getAttribute('aria-controls') : null;

    var listScrollTop = null;
    if (openId) {
      var openList = document.querySelector('#' + openId + ' .facet-mobile-dropdown__list');
      if (openList) listScrollTop = openList.scrollTop;
    }

    var pillsScrollLeft = null;
    var pillsEl = document.getElementById('FacetMobilePills');
    if (pillsEl) pillsScrollLeft = pillsEl.scrollLeft;

    container.innerHTML = parsedContainer.innerHTML;

    if (openId) {
      var dropdown = document.getElementById(openId);
      var btn = document.querySelector('[aria-controls="' + openId + '"]');
      if (dropdown && btn) {
        dropdown.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        if (listScrollTop !== null) {
          var restoredList = dropdown.querySelector('.facet-mobile-dropdown__list');
          if (restoredList) restoredList.scrollTop = listScrollTop;
        }
      }
    }

    if (pillsScrollLeft !== null) {
      var restoredPills = document.getElementById('FacetMobilePills');
      if (restoredPills) restoredPills.scrollLeft = pillsScrollLeft;
    }

    var pills = document.getElementById('FacetMobilePills');
    var track = pills && pills.closest('.facets-mobile-pills-track');
    if (pills && track) {
      var updateScrollHint = function() {
        var atEnd = pills.scrollLeft + pills.clientWidth >= pills.scrollWidth - 4;
        track.classList.toggle('is-scrolled-end', atEnd);
        var hint = track.querySelector('.facets-mobile-scroll-hint');
        if (hint) hint.style.opacity = atEnd ? '0' : '0.5';
      };
      pills.addEventListener('scroll', updateScrollHint, { passive: true });
      requestAnimationFrame(function() { requestAnimationFrame(updateScrollHint); });
      setTimeout(updateScrollHint, 300);
      if (window.ResizeObserver) new ResizeObserver(updateScrollHint).observe(pills);
    }
  }

  static renderDesktopFacets(html) {
    var container = document.getElementById('FacetsDesktopContainer');
    if (!container) return;

    var parsedContainer = new DOMParser().parseFromString(html, 'text/html').getElementById('FacetsDesktopContainer');
    if (!parsedContainer) return;

    var openBtn = document.querySelector('.facet-text-btn[aria-expanded="true"]');
    var openId = openBtn ? openBtn.getAttribute('aria-controls') : null;

    var listScrollTop = null;
    if (openId) {
      var openList = document.querySelector('#' + openId + ' .facet-text-dropdown__list');
      if (openList) listScrollTop = openList.scrollTop;
    }

    container.innerHTML = parsedContainer.innerHTML;

    if (openId) {
      var dropdown = document.getElementById(openId);
      var btn = document.querySelector('[aria-controls="' + openId + '"]');
      if (dropdown && btn) {
        dropdown.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        if (listScrollTop !== null) {
          var restoredList = dropdown.querySelector('.facet-text-dropdown__list');
          if (restoredList) restoredList.scrollTop = listScrollTop;
        }
      }
    }
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.renderPageId = 0;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});

var facetCloseTimer = null;

function closeAllFacetDropdowns() {
  document.querySelectorAll('.facet-text-btn[aria-expanded="true"]').forEach(function(btn) {
    btn.setAttribute('aria-expanded', 'false');
    var id = btn.getAttribute('aria-controls');
    var d = document.getElementById(id);
    if (d) {
      d.hidden = true;
      var list = d.querySelector('.facet-text-dropdown__list');
      if (list) list.scrollTop = 0;
    }
  });
}

window.toggleFacetDropdown = function(button) {
  var dropdownId = button.getAttribute('aria-controls');
  var dropdown = document.getElementById(dropdownId);
  var isOpen = button.getAttribute('aria-expanded') === 'true';

  document.querySelectorAll('.facet-text-btn[aria-expanded="true"]').forEach(function(btn) {
    if (btn !== button) {
      btn.setAttribute('aria-expanded', 'false');
      var id = btn.getAttribute('aria-controls');
      var d = document.getElementById(id);
      if (d) {
        d.hidden = true;
        var list = d.querySelector('.facet-text-dropdown__list');
        if (list) list.scrollTop = 0;
      }
    }
  });

  button.setAttribute('aria-expanded', String(!isOpen));
  dropdown.hidden = isOpen;
  var list = dropdown.querySelector('.facet-text-dropdown__list');
  if (list) list.scrollTop = 0;
};

document.addEventListener('click', function(e) {
  if (!e.target.closest('.facet-text-wrapper')) {
    closeAllFacetDropdowns();
  }
});

document.addEventListener('mouseout', function(e) {
  var wrapper = e.target.closest('.facet-text-wrapper');
  if (!wrapper) return;
  var related = e.relatedTarget;
  if (related && wrapper.contains(related)) return;
  clearTimeout(facetCloseTimer);
  facetCloseTimer = setTimeout(closeAllFacetDropdowns, 150);
});

document.addEventListener('mouseover', function(e) {
  if (e.target.closest('.facet-text-wrapper')) {
    clearTimeout(facetCloseTimer);
  }
});

window.toggleMobileFacet = function(button) {
  var dropdownId = button.getAttribute('aria-controls');
  var dropdown = document.getElementById(dropdownId);
  var isOpen = button.getAttribute('aria-expanded') === 'true';

  document.querySelectorAll('.facet-mobile-dropdown').forEach(function(d) {
    if (!d.hidden) {
      d.hidden = true;
      var list = d.querySelector('.facet-mobile-dropdown__list');
      if (list) list.scrollTop = 0;
    }
  });
  document.querySelectorAll('.facet-pill[aria-expanded="true"]').forEach(function(b) {
    b.setAttribute('aria-expanded', 'false');
  });

  if (!isOpen) {
    button.setAttribute('aria-expanded', 'true');
    if (dropdown) {
      dropdown.hidden = false;
      var list = dropdown.querySelector('.facet-mobile-dropdown__list');
      if (list) list.scrollTop = 0;
    }
  }
};